import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { FooterComponent } from './footer.component';
import { MenubarModule } from 'primeng/menubar';

@NgModule({
    imports: [CommonModule, SharedModule, MenubarModule, FooterComponent],
    exports: [FooterComponent],
    providers: [],
})
export class FooterModule {}
